import axios from "axios";
import { FUNDS } from "../../../constants/api";
import {
  FUNDS_AUTO_UPDATE_TIME_INTERVAL,
  FUNDS_PROPERTY_NAME,
} from "../../../constants";

export const FUNDS_FETCH_SUCCESS = "funds/fetch_success";
export const FUNDS_FETCH_STARTED = "funds/fetch_started";
export const FUNDS_FETCH_FAILURE = "funds/fetch_failure";

let autoUpdateIntervalId;

export const startFundsAutoUpdate = (force) => async (dispatch) => {
  window.clearInterval(autoUpdateIntervalId);

  dispatch(fetchFunds(force));

  autoUpdateIntervalId = window.setInterval(
    () => dispatch(fetchFunds()),
    FUNDS_AUTO_UPDATE_TIME_INTERVAL
  );
};

export const stopFundsAutoUpdate = () => {
  window.clearInterval(autoUpdateIntervalId);
};

const fetchFunds = (force) => async (dispatch) => {
  dispatch(fetchFundsStarted());

  const stringFunds = localStorage.getItem(FUNDS_PROPERTY_NAME);
  const cachedFunds = stringFunds && JSON.parse(stringFunds);
  const lastUpdate =
    cachedFunds?.lastUpdate ||
    Date.now() - (FUNDS_AUTO_UPDATE_TIME_INTERVAL + 1);

  const now = Date.now();

  if (now - lastUpdate > FUNDS_AUTO_UPDATE_TIME_INTERVAL || force) {
    try {
      const fundsResponse = await axios.get(FUNDS);

      dispatch(fetchFundsSuccess(fundsResponse?.data?.result));
    } catch (e) {
      dispatch(fetchFundsFailure(e.message));
    }
  } else {
    dispatch(fetchFundsSuccess(cachedFunds.funds, true));
  }
};

const fetchFundsStarted = () => ({
  type: FUNDS_FETCH_STARTED,
});

const fetchFundsSuccess = (funds, fromCache) => {
  if (!fromCache) {
    const fundsCache = { lastUpdate: Date.now(), funds };
    localStorage.setItem(FUNDS_PROPERTY_NAME, JSON.stringify(fundsCache));
  }

  return {
    type: FUNDS_FETCH_SUCCESS,
    payload: {
      ...funds,
    },
  };
};

const fetchFundsFailure = (error) => ({
  type: FUNDS_FETCH_FAILURE,
  payload: {
    error,
  },
});
